// extracted by mini-css-extract-plugin
export default {"content":"WagonsCalendarPage_content__3rYom"};